import { Module } from '@nestjs/common';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { appConfig } from '../../config';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ServeStaticModule } from '@nestjs/serve-static';
import { join } from 'path';
import { NeedleModelModule } from './masters/needle-model/needle-model-module';
import { StyleModule } from './masters/style/style-module';
import { NeedleSizesModule } from './needle-sizes/needle-sizes-module';
import { StockInService } from './stock-in/stock-in.service';
import { StockInController } from './stock-in/stock-in.controller';
import { StockInModule } from './stock-in/stock-in.module';
import { MachinesModule } from './machine/machines-module';
import { PointTypeModule } from './point-type/point-type-module';
import { MachineNeedleMappingModule } from './machine-needle-mapping/machine-needle-mapping.module';
import { MaterialRequestModule } from './material-request/material-request-module';
import { NeedleReturnProductionModule } from './needle-return-after-production/needle-return-after-production.module';
import { StockOutModule } from './stock-in/stock-out-module';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: "mysql",
      timezone: 'Z',
   host: appConfig.database.host,
      port: appConfig.database.port,
      username: appConfig.database.username,
      password: appConfig.database.password,
      database: appConfig.database.dbName,
      // host: "localhost",
      // port: 3306,
      // username: "root",
      // password: "",
      // database: "test_sampling",
      autoLoadEntities: true,
      synchronize: false,
      logging: true,
      extra: {
        connectionLimit: 20
      }
    }),
    ServeStaticModule.forRoot({
      // rootPath: join(__dirname, '..', '..', '..', '..', 'dist','packages','services','common','upload_files'),
      rootPath: join(__dirname, '../../../../', 'upload_files'),
      serveRoot: '/static',
      serveStaticOptions: {
        redirect: false,
        index: false
      }
    }),
    
    NeedleModelModule,
    StyleModule,
    NeedleSizesModule,StockInModule,
    MachineNeedleMappingModule,
    NeedleReturnProductionModule,
    StockOutModule,
    NeedleSizesModule,
    StockInModule,
      MachinesModule,
    PointTypeModule,
    MachineNeedleMappingModule,
    MaterialRequestModule
     
    ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }